import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timer"]
  static values = { startedAt: String, sessionId: Number }

  connect() {
    this.elapsed = this.loadElapsed()
    this.paused = document.hidden
    this.updateDisplay()

    this.interval = setInterval(() => {
      if (!this.paused) {
        this.elapsed++
        this.updateDisplay()
        this.saveElapsed()
      }
    }, 1000)

    this.boundVisibility = this.onVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.boundVisibility)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
    document.removeEventListener("visibilitychange", this.boundVisibility)
    this.saveElapsed()
  }

  onVisibilityChange() {
    this.paused = document.hidden
  }

  updateDisplay() {
    const hours = Math.floor(this.elapsed / 3600)
    const minutes = Math.floor((this.elapsed % 3600) / 60)
    const seconds = this.elapsed % 60
    const pad = (n) => String(n).padStart(2, "0")

    this.timerTarget.textContent = hours > 0
      ? `${hours}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`
  }

  storageKey() {
    return `phoning_timer_${this.sessionIdValue || "default"}`
  }

  loadElapsed() {
    const saved = sessionStorage.getItem(this.storageKey())
    return saved ? parseInt(saved, 10) : 0
  }

  saveElapsed() {
    sessionStorage.setItem(this.storageKey(), String(this.elapsed))
  }
}
